import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DataSource } from '@angular/cdk/table';

import { CollectionViewer } from '@angular/cdk/collections';
// tslint:disable-next-line:import-blacklist
import { Observable,fromEvent, BehaviorSubject ,  of } from 'rxjs';

import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ReimburseDialogComponent } from '../reimburse-dialog/reimburse-dialog.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ChangeInvoiceStatusDialogComponent } from '../change-invoice-status-dialog/change-invoice-status-dialog.component';
import { RecreateReportComponent } from '../recreate-report/recreate-report.component';
import { CancelReportComponent } from '../cancel-report/cancel-report.component';
import { MatPaginator } from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-jaldee-reimburse',
  templateUrl: './jaldee-reimburse.component.html',
  styleUrls: ['./jaldee-reimburse.component.css']
})

export class JaldeeReimburseComponent implements OnInit , AfterViewInit {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  dataSource = new JaldeeReportDataSource( this.jaldeeReportService);
  displayedColumns: string[] = ['invoiceId', 'fromDate', 'toDate',  'regenerste', 'invoiceStatus'];
  selectedRowIndex = -1;
  report: any;
  showToolBar = false;
  tableFilters = '';
  @ViewChild('go', {static: false}) button: ElementRef;
  reportCount = 10;
  showInvoiceBtn = false;
  subDomains: any[];
  serviceSectors: any;
  domain: any;
  fromDate;
  toDate;
  collapsed;
  baseLocationModel;
  baseLocation;
  reimburseid;
  showChangeInvoiceStatusBtn = false;
  configData: any = {};
  ReimburseStatus: any = [];
  showReimburse = true;
  showcancel = true;
  ynwDomain: any;
  isrecreate;
  constructor(private jaldeeReportService: JaldeeReportService, private commonService: CommonfilterService,private dialog: MatDialog, private commonFilter: CommonfilterService) {
   this.commonFilter.getConfigData()
   .subscribe(res => {
     this.configData = res;
     console.log(this.configData);
     this.ReimburseStatus = this.configData.reportStatusDetails;
   });
   this.commonService.getConfigData()
   .subscribe(config => {
     this.configData = config;
     // console.log('congifData' + JSON.stringify(this.configData));
    
     this.ynwDomain = this.configData.ynwDomain;
     console.log(this.ynwDomain);
    //  if(this.ynwDomain === 'https://sascale.jaldee.com'){

    //  }
   });
   this.commonFilter.getS3UrlFromBackend()
   .subscribe(res => {
     this.commonFilter.setS3Url(res);
   });
   }
  ngOnInit() {
    this.dataSource.loadJaldeeReport(this.tableFilters, 'false', 0, 10);
    this.getTotalCountByFilters(this.tableFilters);
  }

  onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      // tslint:disable-next-line:triple-equals
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({'displayName': this.serviceSectors[i].subDomains[j].displayName,
           'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain});
          }
        }
      }
    }
    ngAfterViewInit() {

      this.paginator.page
      .pipe(
          tap(() => this.loadReportsPage())
      )
      .subscribe();
      fromEvent(this.button.nativeElement, 'click')
      .pipe(
          debounceTime(150),
          distinctUntilChanged(),
          tap(() => {
              this.tableFilters = this.commonFilter.createfilterParams('reimburse');
              // console.log('table filterss....' + this.tableFilters);
             this.getTotalCountByFilters(this.tableFilters);
              this.paginator.pageIndex = 0;
              this.loadReportsPage();
          })
      )
      .subscribe();
  }
getTotalCountByFilters(filter) {
 // console.log('filters...' + filter);
  this.jaldeeReportService.getTotalReportFilterCount(filter)
  .subscribe( data => this.reportCount = data);
  console.log(this.reportCount);
 }

loadReportsPage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 10;

  this.dataSource.loadJaldeeReport(

    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize
    );
}

  onReportCliked(row) {
    this.showInvoiceBtn = false;
    this.showToolBar = false;
    this.showReimburse = true;
    this.showChangeInvoiceStatusBtn = false;
    this.selectedRowIndex = row.invoiceId;
    this.isrecreate = row.id;
    console.log(this.isrecreate)
    console.log('row status........' + row.status);
    if (row.status === 'INDISPUTE') {
          this.showReimburse = false;
          this.showInvoiceBtn = true;

      }
      if (row.status === 'PAYMENTPENDING') {
        this.showInvoiceBtn = true;
      }
    this.report = row;
    this.showToolBar = true;
    this.selectedRowIndex = row.id;
    if (row.status === 'ACTIVE') {
      this.showToolBar = true;
    }  else {
      this.showToolBar =  false;
    }
  }
  reimburse() {
    const dialogReference = this.dialog.open(ReimburseDialogComponent, {
      width : '1000px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  recreate() {
    const dialogReference = this.dialog.open(RecreateReportComponent, {
      width : '900px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  cancel() {
    const dialogReference = this.dialog.open(CancelReportComponent, {
      width : '900px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  changeInvoiceStatus() {
    const dialogReference = this.dialog.open(ChangeInvoiceStatusDialogComponent, {
      width : '900px',
      data: this.report
    });
    dialogReference.afterClosed().subscribe(result => {
      this.loadReportsPage();
      this.showToolBar = false;
      this.selectedRowIndex = -1;
    });
  }
  }




export class JaldeeReportDataSource extends DataSource<any> {


  private jaldeeReportSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor( private reportService: JaldeeReportService) {
    super();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.jaldeeReportSubject.complete();
    this.loadingSubject.complete();
  }
  connect(): Observable<any> {
    return this.jaldeeReportSubject.asObservable();
  }

  loadJaldeeReport( filter,
    sortDirection, count, pageSize) {
    this.loadingSubject.next(true);
    this.reportService.getReimburseReports( filter, sortDirection,
      count, pageSize ).pipe(
       catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(reports =>
         this.jaldeeReportSubject.next(reports)
         );
    }
}
